import React, { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../../services/PostTemplate";
import * as Yup from "yup";

function ApproveTransaction({ status, fileHeadId, authDetailId, onHide, getGroup, callBackForTransactionDisable }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");

    const validationSchema = Yup.object().shape({
        comments: Yup.string().required("Required").max(200),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            comments: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.comments) {
                errors.comments = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["action"] = status;
            data["authDetailId"] = authDetailId;
            data["fileHeadId"] = fileHeadId;
            await handlePostRequest(data, "zbizgateway/customerFileUpload/authorizeUploadedFile");
            onHide();
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
            getGroup()
            callBackForTransactionDisable(true)
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card card_dialog">

                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-12">
                            <div className="p-field">
                                <label htmlFor="comments" className={classNames({ "p-error": isFormFieldValid("comments") }, "Label__Text")}>
                                    Comments<span className="Label__Required">*</span>
                                </label>
                                <InputTextarea placeholder="Add Comments" id="comments" name="comments" value={formik.values.comments} rows={5} cols={10} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("comments") }, "TextArea__Round")} />
                                {getFormErrorMessage("comments")}
                            </div>
                        </div>
                    </div>
                    <div className="GenerateDown__Btn p-mt-4">
                        <Button disabled={loading} type="submit" label="Ok" className="Btn__Transparent" />
                    </div>
                </form>
            </div>
        </>
    );
}

export default ApproveTransaction;
